import { createGetEndpoint } from '@sonar-software/sonar-http';
import { InitiativeStakeholder } from '@types';
import { RelatedCounts } from '@sonar-software/sonar-ts-types';

export type GetInitiativeSummaryRequest = {
	initiativeId: number;
};

export type GetInitiativeSummaryResponse = {
	initiativeId: number;
	scopeCounts: RelatedCounts;
	ownerIds: Array<number>;
	stakeholders: InitiativeStakeholder[];
};

export const getInitiativeSummary = createGetEndpoint<GetInitiativeSummaryRequest, GetInitiativeSummaryResponse>(
	(request) => `/api/v3/initiatives/${request.initiativeId}/summary`
);
